import Immutable from 'immutable';
import urlResolver from 'admin/utils/URLResolver';
import AccessStatus from 'edrolo/constants/AccessStatus';
import { get, post } from 'edrolo/domains/net';

export async function loadCourseAssemblage(classId) {
  const url = urlResolver.reverse('api:course-assemblage', { classId });
  return get(url);
}

// TBC: check if we still need this?
// TODO: refactor endpoint to avoid wrangling
export async function loadUserCourseProgress(userId, classId) {
  const url = urlResolver.reverse('api:user-progress-course', {
    userId,
    classId,
  });
  return get(url, {
    transformBody: (body) =>
      Immutable.Map({
        video_count: body.get('video_count'),
        videos_watched: body.get('videos_watched'),
        lessons: body
          .get('lessons', Immutable.List())
          .toMap()
          .mapKeys((_, lesson) => String(lesson.get('lesson_id'))),
        lessons_with_notes_taken: body.get(
          'lessons_with_notes_taken',
          Immutable.List()
        ),
        exams: body
          .get('sittings', Immutable.List())
          .toMap()
          .mapKeys((_, sitting) => String(sitting.get('exam'))),
        locked_exam_ids: body
          .get('locked_exam_ids', Immutable.List())
          .map((id) => `${id}`)
          .toSet(),
      }),
  });
}

export async function loadSchoolClassProgress(classId) {
  const url = urlResolver.reverse('api:class-course-progress', { classId });
  return get(url, {
    transformBody: (body) =>
      Immutable.Map({
        chunk_count_total: body.get('chunk_count_total'),
        chunk_visit_count_avg: body.get('chunk_visit_count_avg'),
        lessons: body
          .get('lessons', Immutable.List())
          .toMap()
          .mapKeys((_, lesson) => String(lesson.get('lesson_id'))),
        exams: body
          .get('exams', Immutable.List())
          .toMap()
          .mapKeys((_, exam) => String(exam.get('exam_id'))),
      }),
  });
}

export async function loadClassDetail(classId) {
  const url = urlResolver.reverse('api:class-detail', { classId });
  return get(url, {
    transformBody: (body) =>
      Immutable.Map({
        course_id: body.get('course_id'),
        course_title: body.get('course_title'),
        class_type: body.get('class_type'),
        expiration_date: body.get('expiration_date'),
        calendar_year: body.get('calendar_year'),
        title: body.get('title'),
        features: body.get('features'),
        activation_link: body.get('activation_link'),
        students: body
          .get('enrolments', Immutable.List())
          .filter(
            (enrolment) => enrolment.get('access_status') >= AccessStatus.LOCKED
          )
          .map((enrolment) =>
            Immutable.Map({
              profile_id: enrolment.getIn(['profile', 'id']),
              user_id: enrolment.getIn(['profile', 'user']),
              display_name: enrolment.getIn(['profile', 'name']),
              first_name: enrolment.getIn(['profile', 'first_name']),
              last_name: enrolment.getIn(['profile', 'last_name']),
              is_active: enrolment.getIn(['profile', 'is_active']),
            })
          )
          .toOrderedMap()
          .mapKeys((_, student) => String(student.get('profile_id')))
          .sortBy(
            (student) =>
              `${student.get('last_name')}-${student.get('display_name')}`,
            (a, b) => a.localeCompare(b)
          ),
      }),
  });
}

export async function setExamLocked(classId, examId, isLocked) {
  const url = urlResolver.reverse('api:class-exam-lock', {
    classId,
    examId,
  });
  return post(url, { status: isLocked ? 'LOCKED_BY_TEACHER' : 'OPEN' });
}

export async function setLessonSelfRating(lessonId, rating) {
  const url = urlResolver.getPath('ajax:self-assessment');
  const data = {
    branch_id: lessonId,
    rating,
  };

  return post(url, data);
}
